// Version debug de la wishlist - simplifiée pour tester
console.log('Wishlist script loaded');

class Wishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    console.log('Wishlist constructor called');
    this.init();
  }

  init() {
    console.log('Wishlist init started');
    this.bindEvents();
    this.updateWishlistCount();
    console.log('Wishlist init completed');
  }

  // Récupérer la wishlist depuis localStorage
  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      const result = wishlist ? JSON.parse(wishlist) : [];
      console.log('Current wishlist:', result);
      return result;
    } catch (error) {
      console.error('Error getting wishlist:', error);
      return [];
    }
  }

  // Sauvegarder la wishlist dans localStorage
  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
      console.log('Wishlist saved:', wishlist);
      this.updateWishlistCount();
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }
  }

  // Ajouter un produit à la wishlist
  addToWishlist(productId, productTitle, productPrice, productImage, productUrl) {
    console.log('Adding to wishlist:', { productId, productTitle, productPrice, productImage, productUrl });
    
    const wishlist = this.getWishlist();
    
    // Vérifier si le produit existe déjà
    const existingProduct = wishlist.find(item => item.id === productId);
    
    if (!existingProduct) {
      const product = {
        id: productId,
        title: productTitle,
        price: productPrice,
        image: productImage,
        url: productUrl,
        addedAt: new Date().toISOString()
      };
      
      wishlist.push(product);
      this.saveWishlist(wishlist);
      this.showNotification(`${productTitle} ajouté à votre wishlist`);
      this.updateWishlistButtons(productId, true);
      console.log('Product added successfully');
    } else {
      console.log('Product already in wishlist');
      this.showNotification(`${productTitle} est déjà dans votre wishlist`);
    }
  }

  // Supprimer un produit de la wishlist
  removeFromWishlist(productId) {
    console.log('Removing from wishlist:', productId);
    
    const wishlist = this.getWishlist();
    const product = wishlist.find(item => item.id === productId);
    const updatedWishlist = wishlist.filter(item => item.id !== productId);
    
    this.saveWishlist(updatedWishlist);
    this.updateWishlistButtons(productId, false);
    
    if (product) {
      this.showNotification(`${product.title} retiré de votre wishlist`);
      console.log('Product removed successfully');
    }
    
    // Mettre à jour la page wishlist si on y est
    this.renderWishlistPage();
  }

  // Vérifier si un produit est dans la wishlist
  isInWishlist(productId) {
    const wishlist = this.getWishlist();
    const result = wishlist.some(item => item.id === productId);
    console.log(`Product ${productId} in wishlist:`, result);
    return result;
  }

  // Mettre à jour le compteur de la wishlist
  updateWishlistCount() {
    const wishlist = this.getWishlist();
    const count = wishlist.length;
    console.log('Updating wishlist count:', count);
    
    const countElements = document.querySelectorAll('.wishlist-count');
    console.log('Found count elements:', countElements.length);
    
    countElements.forEach(element => {
      element.textContent = count;
      element.style.display = count > 0 ? 'inline' : 'none';
    });
  }

  // Mettre à jour l'état des boutons wishlist
  updateWishlistButtons(productId, isInWishlist) {
    console.log(`Updating buttons for product ${productId}, isInWishlist: ${isInWishlist}`);
    
    const buttons = document.querySelectorAll(`[data-product-id="${productId}"]`);
    console.log('Found buttons:', buttons.length);
    
    buttons.forEach(button => {
      const iconElement = button.querySelector('.wishlist-icon');
      
if (isInWishlist) {
  button.classList.add('in-wishlist');
  if (iconElement) {
    iconElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
      </svg>
    `;
  }
} else {
  button.classList.remove('in-wishlist');
  if (iconElement) {
    iconElement.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
      </svg>
    `;
  }
}
    });
  }

  // Lier les événements
  bindEvents() {
    console.log('Binding events');
    
    document.addEventListener('click', (e) => {
      console.log('Click detected on:', e.target);
      
      // Bouton d'ajout/suppression
      if (e.target.closest('.wishlist-btn')) {
        e.preventDefault();
        console.log('Wishlist button clicked');
        
        const button = e.target.closest('.wishlist-btn');
        const productId = button.dataset.productId;
        
        console.log('Product ID:', productId);
        console.log('Button dataset:', button.dataset);
        
        if (!productId) {
          console.error('No product ID found on button');
          return;
        }
        
        if (this.isInWishlist(productId)) {
          console.log('Removing from wishlist');
          this.removeFromWishlist(productId);
        } else {
          console.log('Adding to wishlist');
          const productTitle = button.dataset.productTitle;
          const productPrice = button.dataset.productPrice;
          const productImage = button.dataset.productImage;
          const productUrl = button.dataset.productUrl;
          
          if (!productTitle) {
            console.error('Missing product data on button');
            return;
          }
          
          this.addToWishlist(productId, productTitle, productPrice, productImage, productUrl);
        }
      }

      // Bouton de suppression dans la page wishlist
      if (e.target.closest('.remove-from-wishlist')) {
        e.preventDefault();
        console.log('Remove button clicked');
        
        const button = e.target.closest('.remove-from-wishlist');
        const productId = button.dataset.productId;
        this.removeFromWishlist(productId);
      }
    });
  }

  // Mettre à jour tous les boutons wishlist
  updateAllButtons() {
    console.log('Updating all buttons');
    const buttons = document.querySelectorAll('.wishlist-btn');
    console.log('Found total buttons:', buttons.length);
    
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      if (productId) {
        const isInWishlist = this.isInWishlist(productId);
        this.updateWishlistButtons(productId, isInWishlist);
      }
    });
  }

  // Afficher une notification simple
  showNotification(message) {
    console.log('Showing notification:', message);
    
    // Version simple avec alert pour debug
    alert(message);
    
    // TODO: Remplacer par une notification plus élégante une fois que ça fonctionne
  }

  // Rendre la page wishlist (version simplifiée)
  renderWishlistPage() {
    const container = document.querySelector('.wishlist-container');
    if (!container) {
      console.log('No wishlist container found on page');
      return;
    }

    console.log('Rendering wishlist page');
    const wishlist = this.getWishlist();
    
    if (wishlist.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <h2>Votre wishlist est vide</h2>
          <p>Ajoutez des produits à votre wishlist depuis les fiches produits</p>
        </div>
      `;
      return;
    }

    const wishlistHTML = wishlist.map(product => `
      <div class="wishlist-item" style="border: 1px solid #ddd; padding: 20px; margin: 10px 0;">
        <h3>${product.title}</h3>
        <p>Prix: ${product.price}</p>
        <img src="${product.image}" alt="${product.title}" style="max-width: 100px;">
        <br>
        <a href="${product.url}">Voir le produit rtser</a>
        <button class="remove-from-wishlist" data-product-id="${product.id}" style="margin-left: 10px;">
          Retirer
        </button>
      </div>
    `).join('');

    container.innerHTML = `
      <h1>Ma Wishlist (${wishlist.length})</h1>
      ${wishlistHTML}
    `;
  }

  // Vider complètement la wishlist
  clearWishlist() {
    console.log('Clearing wishlist');
    localStorage.removeItem(this.storageKey);
    this.updateWishlistCount();
    this.updateAllButtons();
    this.renderWishlistPage();
    this.showNotification('Wishlist vidée');
  }
}

// Initialiser la wishlist quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing wishlist');
  window.wishlist = new Wishlist();
  
  // Mettre à jour les boutons après un petit délai pour être sûr
  setTimeout(() => {
    if (window.wishlist) {
      window.wishlist.updateAllButtons();
    }
  }, 100);
});

// Exposer les méthodes globalement pour l'utilisation dans les templates
window.addToWishlist = (productId, productTitle, productPrice, productImage, productUrl) => {
  console.log('Global addToWishlist called');
  if (window.wishlist) {
    window.wishlist.addToWishlist(productId, productTitle, productPrice, productImage, productUrl);
  } else {
    console.error('Wishlist not initialized');
  }
};

window.removeFromWishlist = (productId) => {
  console.log('Global removeFromWishlist called');
  if (window.wishlist) {
    window.wishlist.removeFromWishlist(productId);
  } else {
    console.error('Wishlist not initialized');
  }
};

window.isInWishlist = (productId) => {
  if (window.wishlist) {
    return window.wishlist.isInWishlist(productId);
  }
  return false;
};

// Test du localStorage
try {
  localStorage.setItem('test', 'test');
  localStorage.removeItem('test');
  console.log('localStorage is working');
} catch (error) {
  console.error('localStorage not available:', error);
}